import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function AllergicRhinitis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-01-allergic-rhinitis-page"}>
            <div className="pageWrapper">
                <DetailHeader diseaseName={"Allergic Rhinitis"}></DetailHeader>
                <div className="MainContent">
                    <div className="container">
                        <div className="page-rte">
                            <p>
                                Type to enter textAllergic rhinitis is <b>inflammation of the inside of
                                the nose caused by an allergen,</b> such as pollen, dust, mould or
                                flakes of skin from certain animals. It's a very common condition,
                                estimated to affect around 1 in every 5 people in the UK.
                            </p>
                            <div className="row">
                                <div className="col-12 textCenter">
                                    <img src={require("../../img/Disease/Allergic-Rhinitis/1.png")} alt="allergic-rhinitis" />
                                </div>
                            </div>

                            <p>
                                <b>Symptoms</b>
                            </p>
                            <ul className="listUnstyle">
                                <li>Stuffy itchy nose </li>
                                <li><a className='links' href='https://en.wikipedia.org/wiki/Sneezing'>Sneezing</a></li>
                                <li>Red, itchy</li>
                                <li>Watery eyes </li>
                                <li>Swelling around the eyes</li>
                                <li>Itchy ears</li>
                            </ul>

                            <a className="links" href="https://en.wikipedia.org/">
                                For More Details
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default AllergicRhinitis;